import { Amplify } from 'aws-amplify';
import localhost from './localhost';
import test_tailor_wf from './test.tailor.wf';
import tailor_wf from './tailor.wf';
import localhost_apitest from './localhost-apitest';
import go_dev_entail_io from './go-dev.entail.io';
import go_prod_entail_io from './go-prod.entail.io';
import localhost_go_dev from './localhost-go-dev';

switch (import.meta.env.VITE_APP_ENV) {
  case 'prod':
    Amplify.configure(tailor_wf);
    break;
  case 'test':
    Amplify.configure(test_tailor_wf);
    break;
  case 'go-dev':
    Amplify.configure(go_dev_entail_io);
    break;
  case 'go-prod':
    Amplify.configure(go_prod_entail_io);
    break;
  case 'localhost-go-dev':
    Amplify.configure(localhost_go_dev);
    break;
  case 'dev':
    Amplify.configure(localhost);
    break;
  case 'arne':
    Amplify.configure(localhost_apitest);
    break;
}
